import AsyncSelect from "react-select/async";
import debounce from "debounce-promise";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

import { searchClients } from "api/api";
import { useRemindersStore } from "store/RemindersStore";
import { useAppStoreState } from "store/AppStore";
import { useRemindersCreateDialogStore } from "store/RemindersCreateDialogStore";

const SearchClients = () => {
  const { t } = useTranslation();
  const { clientId } = useParams() as any;
  const [
    { clSearchPayersSelectedItem, clIsPayerReminder },
    { setRemindersCreateDialogStoreValue },
  ] = useRemindersCreateDialogStore();

  const isDisabled = !!clientId || clIsPayerReminder;
  const { appState } = useAppStoreState();

  const customStyles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: appState.darkMode ? "#222222" : "white", // Or any desired color
      color: appState.darkMode ? "white" : "#222222", // Or any desired color
      width: "90%",
      zIndex: 9999,
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      // minHeight: "30px", // reduce the height
      // height: "30px",
      // padding: "0 6px",

      backgroundColor: appState.darkMode ? "#222222" : "white", // Or any desired color
      color: appState.darkMode ? "white" : "white", // Or any desired color
      width: "90%",
    }),
    valueContainer: (provided) => ({
      ...provided,
      // height: "30px",
      // padding: "0 6px",
      // alignItems: "center", // vertically center the text
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      color: appState.darkMode ? "white" : "#222222",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: appState.darkMode ? "white" : "#222222",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? appState.darkMode
            ? "#000000"
            : "#eeeeee"
          : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? appState.darkMode
            ? "white"
            : "#222222"
          : appState.darkMode
          ? "white"
          : "#222222",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? "yellow"
              : appState.darkMode
              ? "white"
              : "white"
            : undefined,
        },
      };
    },
  };
  return (
    <>
      <AsyncSelect
        id="clientsSearchWide"
        loadOptions={debounce(async (input) => {
          const trimmedInput = input.trim();
          if (trimmedInput.length === 0) return [];
          const clients = await searchClients(trimmedInput);
          return clients.data.map((c) => {
            return {
              label:
                c.name + (c.internalNumber ? ` (${c.internalNumber})` : ""),
              value: c,
            };
          });
        }, 300)}
        styles={customStyles}
        menuPlacement={"auto"}
        placeholder={t("pct.searchClients.label")}
        noOptionsMessage={() => t("greco.noResults")}
        isClearable
        isDisabled={isDisabled}
        loadingMessage={() => t("greco.searching")}
        value={clSearchPayersSelectedItem}
        onChange={(value) => {
          setRemindersCreateDialogStoreValue(
            "clSearchPayersSelectedItem",
            value
          );
        }}
      />
    </>
  );
};

export default SearchClients;
